/** Production Ecwid Control Panel deep-link for Search IQ. */
export const SEARCHIQ_ECWID_PROD_URL =
  'https://www.ecwid.com/apps/featured/searchiq';

/** Production Ecwid Control Panel deep-link for Quote2Cart. */
export const QUOTE2CART_ECWID_PROD_URL =
  'https://www.ecwid.com/apps/featured/quote2-cart';

/** Production Ecwid Control Panel deep-link for BulkEditPro. */
export const BULKEDITPRO_ECWID_PROD_URL =
  'https://www.ecwid.com/apps/featured/bulkeditpro';

/** Always open in a new tab. */
export function openEcwidUrl(url) {
  const target = String(url || '').trim();
  if (!target) {
    return;
  }
  window.open(target, '_blank', 'noopener,noreferrer');
}

export function openSearchIqEcwidApp() {
  openEcwidUrl(SEARCHIQ_ECWID_PROD_URL);
}

export function openQuote2CartEcwidApp() {
  openEcwidUrl(QUOTE2CART_ECWID_PROD_URL);
}

export function openBulkEditProEcwidApp() {
  openEcwidUrl(BULKEDITPRO_ECWID_PROD_URL);
}
